import { useState } from 'react';
import {
  AddressDto,
  ManualLegDto,
  PostalValidationPayloadDto,
} from '../../../types';
import {
  addressValidationInitialValues,
  addressValidationTrueValues,
} from '../../../initial-values';
import useCountriesList from '../../../hooks/useCountriesList';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import AddressForm from '../../shipment/route/addressForm';
import { validatePostalCode } from '../../../api/shipmentForms';
import { isValidationValidated } from '../../../utils/helper';
import X from '../../../assets/icons/new_icon/x.svg';

interface Props {
  onClose: any;
  manualLegList: ManualLegDto[];
  setManualLegList: any;
  item: any;
  index: number;
  addressType: string;
}
const EditLegAddressModal = ({
  onClose,
  manualLegList,
  setManualLegList,
  item,
  index,
  addressType,
}: Props) => {
  const countriesList = useCountriesList();
  const { provincesList } = useSelector(
    (state: RootState) => state.mainAppData
  );
  const [validating, setValidating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [addressForm, setAddressForm] = useState<AddressDto>(item[addressType]);
  const [addressFormValidations, setAddressFormValidations] = useState(
    addressValidationTrueValues
  );
  const [postalCodeError, setPostalCodeError] = useState(false);

  const handleClose = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  const updateItem = () => {
    const updatedLegList = [...manualLegList];
    const updatedItem = { ...item };

    updatedItem[addressType] = addressForm;

    updatedLegList[index] = updatedItem;
    setManualLegList(updatedLegList);

    onClose();
  };
  function saveHandle() {
    setValidating(true);
    if (!isValidationValidated(addressFormValidations)) return;
    setLoading(true);

    let payload: any = {
      city: addressForm.city,
      country: addressForm.country,
      province: addressForm.province,
      postal_code: addressForm.postal_code,
    };

    validatePostalCode(payload)
      .then((response) => {
        if (!response.data.is_error) {
          setLoading(false);
          updateItem();
        }
      })
      .catch((e) => {
        setLoading(false);
        setPostalCodeError(true);
      });
  }
  return (
    <div
      className='modal'
      id='edit_leg_modal'
      style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5) ' }}
      tabIndex={-1}
      aria-labelledby='edit_legs_modal_label'
      aria-hidden='true'
      onClick={handleClose}
    >
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}
      <div className='modal-dialog modal-md'>
        <div className='modal-content'>
          <div className='modal-header d-flex w-100 justify-content-between px-3 py-2 pt-3'>
            <h3 className='newubbemodalheading '>Edit Address Details</h3>
            <img
              src={X}
              onClick={() => onClose()}
              style={{ cursor: 'pointer' }}
            />
          </div>

          <div className='modal-body'>
            <div className=''>
              <AddressForm
                countriesList={countriesList}
                provincesList={provincesList}
                formData={addressForm}
                validating={validating}
                formValidation={addressFormValidations}
                setFormValidation={setAddressFormValidations}
                postalCodeError={postalCodeError}
                setFormData={setAddressForm}
              />
            </div>
            <div className='row mt-3'>
              <div className='col-sm-12'>
                <p
                  className='btn ubbe-blue-bg p-2 w-100 rounded-3 text-light d-flex m-auto justify-content-center align-items-center mb-2'
                  style={{ maxWidth: '108px', height: '48px' }}
                  onClick={saveHandle}
                >
                  Save
                </p>
                <u
                  className='m-auto d-flex justify-content-center labelText'
                  style={{ cursor: 'pointer' }}
                  aria-label='Close'
                  onClick={onClose}
                >
                  Cancel
                </u>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditLegAddressModal;
